import {
  oneClickDeployModalAction,
  oneClickDeployConfirmationModalAction,
  deployModalAction,
  completeDeployModalAction,
  confirmationModalCloseState,
  confirmationModalOpenState,
  confirmErrorAction,
  loadEntityConfigSuccess
} from '../actions/entity-config.action';
import {createReducer, on} from '@ngrx/store';
import {ConfirmModalConfig} from '../../../shared/models/confirmModalConfig';
import {FlowDeployState} from '../../../shared/models/state/Flow';

const initialState = {
  entityConfig: {},
};

export const entityConfigReducer = createReducer(
  initialState,
  on(loadEntityConfigSuccess, (state, { payload }) => ({...state, entityConfig: payload }))
);

/* Setting the initial state of the modal. */
const initialModalState: ConfirmModalConfig = {
  modalState: false,
  title: '',
  body: '',
  button: {},
  deployState: { actionDeploy: false}
};

/* Creating a reducer that will be used to update the state of the store. */
export const modalConfigReducer = createReducer (
  initialModalState,
  on(confirmationModalOpenState, (state, {config}) =>
    config
  ),
  on(confirmationModalCloseState, (state) => {
    return {
      ...state,
      modalState: !state.modalState
    };
  }),
  on(oneClickDeployModalAction, (state) => {
    return {
      ...state,
      deployState: { type: FlowDeployState.CLICK_DEPLOY, actionDeploy: !state.deployState.actionDeploy }
    };
  }),
  on(oneClickDeployConfirmationModalAction, (state) => {
     return {
       ...state,
       deployState: { type: FlowDeployState.CLICK_DEPLOY, actionDeploy: true }
     };
  }),
  on(deployModalAction, (state) => {
   return {
     ...state,
     deployState: { type: FlowDeployState.DEPLOY, actionDeploy: true }
   };
  }),
  on(completeDeployModalAction, (state) => {
     return {
      ...state,
       deployState: { actionDeploy: false }
     };
  }),
  on(confirmErrorAction, (state, {message}) => {
    return {
      ...state,
      error: message
    };
  })
);

